import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import { CircularProgress, FormControlLabel, Switch } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { useSimulatePurchasesFreeGiftMutation } from "redux/apis/clubFreeGift";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";

const SimulatePurchases = () => {
	const [open, setOpen] = useState<boolean>(false);
	const [fieldValue, setFieldValue] = useState<number>(1);
	const [excludeCurrentUser, setExcludeCurrentUser] = useState<boolean>(true);
	const [simulatePurchasesFreeGift, { isLoading }] =
		useSimulatePurchasesFreeGiftMutation();
	const { showErrorDialog } = useDialogModalRedux();

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setFieldValue(e.target.valueAsNumber);
	};

	const handleSetPurchases = async () => {
		await simulatePurchasesFreeGift({
			body: {
				count: fieldValue,
				excludeCurrentUser: excludeCurrentUser
			}
		})
			.unwrap()
			.then(() => {
				setOpen(false);
			})
			.catch((error) => {
				showErrorDialog({
					data: {
						errorCode: error?.status?.toString(),
						errorMessage: error?.data?.error?.toString()
					}
				});
			});
	};

	return (
		<div>
			<Button variant="outlined" onClick={handleClickOpen}>
				{"Simulate Member Clicks"}
			</Button>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>Submit</DialogTitle>
				<DialogContent>
					<TextField
						onChange={onChange}
						autoFocus
						margin="dense"
						id="name"
						defaultValue={fieldValue}
						label="Simulate Member Clicks"
						type="number"
						fullWidth
						variant="standard"
					/>

					<div>
						<FormControlLabel
							control={
								<Switch
									title="Exclude current user"
									checked={excludeCurrentUser}
									onChange={(e) => setExcludeCurrentUser(e.target.checked)}
								/>
							}
							label="Exclude current user"
							labelPlacement="start"
						/>
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>Cancel</Button>
					<Button onClick={handleSetPurchases}>
						{isLoading ? <CircularProgress size={"0.875rem"} /> : "Submit"}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default SimulatePurchases;
